import { styled, css } from '@creditas/stylitas'

const flexContainerBase = ({
  column,
  minHeight,
  center,
  verticalCenter,
  height,
  maxWidth,
}) => css`
  display: flex;
  flex-direction: ${column ? 'column' : 'row'};
  justify-content: ${center ? 'center' : 'flex-start'};
  align-items: ${center ? 'center' : 'flex-start'};
  height: ${verticalCenter ? '100vh' : height ? height : 'auto'};
  ${minHeight && `min-height: ${minHeight};`}
  margin-left: auto;
  margin-right: auto;
  max-width: ${maxWidth ? maxWidth : '1170px'};
  padding-left: 20px;
  padding-right: 20px;
`

const flexContainerBorder = ({ border }) =>
  border &&
  css`
    border-bottom: 1px solid #bdbdbd;
    padding-bottom: 1rem;
    margin-bottom: 2rem;
  `

const FlexContainer = styled.div`
  ${flexContainerBase}
  ${flexContainerBorder}
`
FlexContainer.displayName = 'FlexContainer'

export { FlexContainer }
